export const serializeQueryParams = (queryParams?: Record<string, string>): string =>
	queryParams
		? new URLSearchParams(
				Object.entries(queryParams).sort(([paramA], [paramB]) => paramA.localeCompare(paramB)),
			).toString()
		: '';
